import { render, staticRenderFns } from "./copyCustom.vue?vue&type=template&id=0e5d6582&scoped=true&"
import script from "./copyCustom.vue?vue&type=script&lang=js&"
export * from "./copyCustom.vue?vue&type=script&lang=js&"
import style0 from "./copyCustom.vue?vue&type=style&index=0&id=0e5d6582&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5d6582",
  null
  
)

export default component.exports